import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'underscore'

import {Card, H5, H3, Panel, ListItem, Modal, ModalHeader, ModalActions, Alert, Button, Badge, S1} from '../../../components/UI/index.js'
import Address from '../../../components/addresses/Address.js'
import {formSpacing, FormRow, FormStack, Select, Toggle, Input, MetricInput, Check, CurrencyInput} from '../../../components/UI/forms/index.js'

class ParcelSettings extends Reflux.Component {
    onChangeValue(key, event) {
        const user = {...this.props.user}

        user.settings[key] = event.target.value

        this.props.onChange(user)
    }

    onChangeAddress(address) {
        const user = {...this.props.user}

        user.settings.parcels.senderAddress = address

        this.props.onChange(user)
    }

    onChangeValueParcels(key, event) {
        const user = {...this.props.user}

        user.settings.parcels[key] = event.target.value

        this.props.onChange(user)
    }

    onChangeValuesParcels(key, event) {
        const user = {...this.props.user}

        user.settings.parcels[key] = event.target.values

        this.props.onChange(user)
    }

    onChangeCheckedParcel(key, event) {
        const user = {...this.props.user}

        user.settings.parcels[key] = event.target.checked

        this.props.onChange(user)
    }

    onNewSize() {
        const user = {...this.props.user}

        const newSize = {
            length: 0,
            width: 0,
            height: 0,
            isDefault: user.settings.parcels.sizes.length === 0
        }

        this.sizeModal.open(newSize, this.onSaveSize.bind(this, user.settings.parcels.sizes.length))
    }

    onSaveSize(index, size) {
        const user = {...this.props.user}

        if (size.isDefault) {
            user.settings.parcels.sizes = user.settings.parcels.sizes.map((size, i) => {
                if (index !== i) {
                    size.isDefault = false
                }
                return size
            })
        }

        user.settings.parcels.sizes[index] = size

        this.props.onChange(user)
        this.sizeModal.close()
    }

    onRemoveSize(index) {
        const user = {...this.props.user}

        user.settings.parcels.sizes.splice(index, 1)

        this.props.onChange(user)
        this.sizeModal.close()
    }

    render() {
        const {reseller, user} = this.props

        let enabledOptions = (_.keys(reseller.settings.parcels.products) || []).filter((product) => {
            return _.some(_.keys(reseller.settings.parcels.products[product]), (carrier) => {
                return reseller.settings.parcels.products[product][carrier]
            })
        }).sort()

        enabledOptions = enabledOptions.map((option) => {
            return {value: option, title: option}
        })

        return (
            <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                <H3 style={{marginBottom: 36}}>Zendingen</H3>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Select
                        label='Standaard weergave'
                        value={user.settings.parcels.defaultDateRange}
                        onChange={this.onChangeValueParcels.bind(this, 'defaultDateRange')}
                    >
                        <option value='today'>Vandaag</option>
                        <option value='week'>Laatste 7 dagen</option>
                        <option value='month'>Laatste 30 dagen</option>
                        <option value='90days'>Laatste 90 dagen</option>
                        <option value='year'>Laatste 365 dagen</option>
                    </Select>
                </FormStack>

                <H5 style={{marginBottom: 24, marginTop: 36}}>Afzender adres</H5>

                <Address
                    noTAV
                    noStreet2
                    address={user.settings.parcels.senderAddress}
                    onChange={this.onChangeAddress.bind(this)}

                />

                <FormStack style={{marginTop: formSpacing.section, marginBottom: formSpacing.rowGap}}>
                    <Select
                        noSort
                        label='Standaard verzendopties'
                        info='Selecteer de opties die standaard gebruikt worden bij het aanmelden van een pakket. De geselecteerde opties zijn niet voor elke zending beschikbaar, als een combinatie van opties niet mogelijk is wordt de voorkeur gegeven aan de eerst geselecteerde optie.'
                        values={user.settings.parcels.defaultOptions || []}
                        options={enabledOptions}
                        onChange={this.onChangeValuesParcels.bind(this, 'defaultOptions')}
                    />

                    {user.settings.parcels.defaultOptions?.includes('Verzekerd') && (
                        <>
                            <CurrencyInput
                                label='Bedrag verzekerd'
                                value={user.settings.parcels?.coverAmount || '0,00'}
                                onChange={this.onChangeValueParcels.bind(this, 'coverAmount')}
                            />
                        </>
                    )}

                    <Input
                        label='Standaard bezorginstructie'
                        info='De bezorginstructie is een opmerking voor de bezorger, niet elke vervoerder maakt gebruik van deze instructie.'
                        value={user.settings.parcels.defaultComment || ''}
                        onChange={this.onChangeValueParcels.bind(this, 'defaultComment')}
                    />

                    <Toggle
                        label='Stuur emailadressen niet naar vervoerders'
                        info='Emailadressen worden niet naar externe vervoerders gestuurd. De ontvanger zal dus geen emails van de vervoerder ontvangen.'
                        checked={user.settings.parcels.dontSendEmailToCarriers}
                        onChange={this.onChangeCheckedParcel.bind(this, 'dontSendEmailToCarriers')}
                    />

                    <Toggle
                        label='Referentie verplicht'
                        info='Bij het aanmaken van een zending is het verplicht een referentie in te vullen.'
                        checked={!!user.settings.parcels.referenceRequired}
                        onChange={this.onChangeCheckedParcel.bind(this, 'referenceRequired')}
                    />

                    <Toggle
                        label='Referentie niet tonen op label'
                        info='De referentie wordt niet doorgestuurd naar externe vervoerders en komt niet op het label te staan.'
                        checked={!!user.settings.parcels.referenceNotOnLabel}
                        onChange={this.onChangeCheckedParcel.bind(this, 'referenceNotOnLabel')}
                    />
                </FormStack>

                {reseller.allowCustomerContracts && (user.settings.parcels.customPostNLContract || user.settings.parcels.customDHLContract) &&
                    <>
                        <H5 style={{marginBottom: 24, marginTop: 36}}>Vervoerders contracten</H5>
                    </>
                }

                {reseller.allowCustomerContracts && user.settings.parcels.customPostNLContract &&
                    <>
                        <S1>PostNL</S1>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input
                                label='Klantnummer'
                                value={user.settings.parcels.postNLCustomerNumber}
                                onChange={this.onChangeValueParcels.bind(this, 'postNLCustomerNumber')}
                            />

                            <Input
                                label='Klantcode'
                                value={user.settings.parcels.postNLCustomerCode}
                                onChange={this.onChangeValueParcels.bind(this, 'postNLCustomerCode')}
                            />

                            <Input
                                label='Klantcode internationaal'
                                value={user.settings.parcels.postNLCustomerCodeInt}
                                onChange={this.onChangeValueParcels.bind(this, 'postNLCustomerCodeInt')}
                            />

                            <Input
                                label='API Key'
                                value={user.settings.parcels.postNLApiKey}
                                onChange={this.onChangeValueParcels.bind(this, 'postNLApiKey')}
                            />
                        </FormStack>
                    </>
                }

                {reseller.allowCustomerContracts && user.settings.parcels.customDHLContract &&
                    <>
                        <S1>DHL</S1>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input
                                label='Klantnummer'
                                value={user.settings.parcels.dhlAccountId}
                                onChange={this.onChangeValueParcels.bind(this, 'dhlAccountId')}
                            />

                            <Input
                                label='Gebruikers ID'
                                value={user.settings.parcels.dhlUserId}
                                onChange={this.onChangeValueParcels.bind(this, 'dhlUserId')}
                            />

                            <Input
                                label='API Key'
                                value={user.settings.parcels.dhlApiKey}
                                onChange={this.onChangeValueParcels.bind(this, 'dhlApiKey')}
                            />
                        </FormStack>
                    </>
                }

                <H5 style={{marginBottom: 24, marginTop: 36}}>Pakketformaten</H5>

                {user.settings.parcels.sizes && user.settings.parcels.sizes.length > 0 &&
                    <Panel style={{marginBottom: 24, maxHeight: 500, overflowY: 'auto'}}>
                        {user.settings.parcels.sizes.map((size, index) => (
                            <ListItem key={index} onClick={() => this.sizeModal.open(size, this.onSaveSize.bind(this, index), this.onRemoveSize.bind(this, index))} style={{justifyContent: 'space-between', height: 'fit-content'}}>
                                <div style={{margin: '1em 0'}}>
                                    <span style={{display: 'flex', alignItems: 'center'}}>{size.name} {size.isDefault && <Badge style={{marginLeft: 12}}>Standaard</Badge>}</span>
                                    <span style={{fontSize: 12, color: 'grey'}}>L: {(size.length / 10).toString().replace('.', ',')}cm x B: {(size.width / 10).toString().replace('.', ',')}cm x H: {(size.height / 10).toString().replace('.', ',')}cm</span>
                                </div>
                            </ListItem>
                        ))}
                    </Panel>
                }

                <Button
                    variant='outline'
                    icon='mdi mdi-plus'
                    label='Nieuw formaat'
                    onClick={this.onNewSize.bind(this)}
                />

                <SizeModal ref={(ref) => this.sizeModal = ref} />
            </Card>
        )
    }
}

class SizeModal extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            size: {
                name: '',
                length: 0,
                width: 0,
                height: 0,
                isDefault: false
            },
            modalIsOpen: false,
            loading: false,
            error: '',
            onSave: undefined,
            onRemove: undefined
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(size, onSave, onRemove) {
        this.setState({
            modalIsOpen: true,
            size: size || this.state.size,
            onSave,
            onRemove
        })
    }

    close() {
        this.setState(this.initialState)
    }

    onSubmit(event) {
        event.preventDefault()
        const {size, onSave} = this.state

        this.setState({loading: true, error: ''})

        if (onSave && typeof onSave === 'function') {
            onSave(size)
        }
    }

    onClickRemove() {
        const {onRemove} = this.state

        this.setState({loading: true, error: ''})
        onRemove()
    }

    setError(error) {
        this.setState({error, loading: false})
    }

    response(err) {
        if (err) {
            this.setState({loading: false, error: err})
        } else {
            this.close()
        }
    }

    onChangeValue(key, event) {
        const {size} = this.state
        if (key !== 'name') {
            size[key] = event.target.value
        } else {
            size[key] = event.target.value
        }

        this.setState({size})
    }

    onChangeChecked(key, event) {
        const {size} = this.state

        size[key] = event.target.checked

        this.setState({size})
    }

    render() {
        const {size, modalIsOpen, error, loading, onRemove} = this.state

        return (
            <Modal show={modalIsOpen} onClose={this.close.bind(this)}>
                <ModalHeader title='Pakket formaat' onClose={this.close.bind(this)} style={{marginBottom: 0}} />

                <form onSubmit={this.onSubmit.bind(this)}>
                    <FormStack>
                        <Input value={size.name} label='Naam' onChange={this.onChangeValue.bind(this, 'name')} />
                        <FormRow>
                            <MetricInput
                                label='Lengte'
                                value={size.length}
                                onChange={this.onChangeValue.bind(this, 'length')}
                                divisionFactor={10}
                                append='cm'
                            />
                            <MetricInput
                                label='Breedte'
                                value={size.width}
                                onChange={this.onChangeValue.bind(this, 'width')}
                                divisionFactor={10}
                                append='cm'
                            />
                            <MetricInput
                                label='Hoogte'
                                value={size.height}
                                onChange={this.onChangeValue.bind(this, 'height')}
                                divisionFactor={10}
                                append='cm'
                            />
                        </FormRow>
                        <Check label='Gebruik als standaard' checked={size.isDefault} onChange={this.onChangeChecked.bind(this, 'isDefault')} />

                        {error &&
                            <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                        }

                        <ModalActions>
                            {onRemove && typeof onRemove === 'function' &&
                                <Button variant='error' onClick={this.onClickRemove.bind(this)} loading={loading}>Verwijder</Button>
                            }
                            <Button type='submit' loading={loading}>Opslaan</Button>
                        </ModalActions>
                    </FormStack>
                </form>
            </Modal>
        )
    }
}

export default (ParcelSettings)
